import React from 'react';

interface BadgeProps {
    children: React.ReactNode;
    variant?: 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'neon';
    size?: 'sm' | 'md';
    className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
    children,
    variant = 'neutral',
    size = 'md',
    className = '',
}) => {
    // Colored dot indicators for each variant
    const dotColors = {
        success: 'bg-success',
        warning: 'bg-amber-400',
        error: 'bg-danger',
        info: 'bg-info',
        neutral: 'bg-white/30',
        neon: 'bg-brand shadow-[0_0_8px_rgba(255,153,28,0.6)]'
    };

    const variants = {
        success: 'bg-success/[0.08] text-success border border-success/15',
        warning: 'bg-amber-500/[0.08] text-amber-400 border border-amber-500/15',
        error: 'bg-danger/[0.08] text-danger border border-danger/15',
        info: 'bg-info/[0.08] text-info border border-info/15',
        neutral: 'bg-white/[0.04] text-white/50 border border-white/[0.06]',
        neon: 'bg-brand/[0.08] text-brand border border-brand/20 shadow-[0_0_12px_rgba(255,153,28,0.12)]',
    };

    const sizes = {
        sm: 'px-2 py-0.5 text-[10px] gap-1',
        md: 'px-2.5 py-1 text-xs gap-1.5',
    };

    return (
        <span
            className={`
                inline-flex items-center justify-center rounded-full font-medium tracking-wide
                ${variants[variant]}
                ${sizes[size]}
                ${className}
            `}
        >
            {/* Status indicator dot */}
            <span className={`w-1.5 h-1.5 rounded-full ${dotColors[variant]} ${variant === 'neon' ? 'animate-pulse' : ''}`} />

            {children}
        </span>
    );
};
